import requests from 'app/requests/RateCard/RateCard.requests'
import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    ContractCurrency,
    AdditionalFeesAllowed, OtherFeesAllowed,
    FeeChargeability, ProductType,
} from 'app/enums/label.enums'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    RateCardsTabs,
} from 'app/enums/domain.enums'
import {
    AdditionalFeesTable,
} from './AdditionalFees.types'

const config: SkyNetTableTab<keyof AdditionalFeesTable> = {
    name: 'Standard Additional Fees',
    url: RateCardsTabs.AdditionalFees,
    customUrl: requests.additionalFeesFilterRequest().url,
    fields: [
        {
            name: 'feeName',
            labelKey: 'LaneFeesRateCard.feeName',
            componentName: 'EnumValue',
            allowedValuesEnum: {
                ...OtherFeesAllowed, ...AdditionalFeesAllowed,
            },
            width: '15%',
        },
        {
            name: 'feeChargability',
            labelKey: 'LaneFeesRateCard.feeChargability',
            componentName: 'EnumValue',
            allowedValuesEnum: FeeChargeability,
            minWidth: '15%',
        },
        {
            name: 'productType',
            labelKey: 'LaneFeesRateCard.productType',
            componentName: 'EnumValue',
            allowedValuesEnum: ProductType,
            minWidth: '7%',
        },
        {
            name: 'simplifiedCQuoteDescription',
            labelKey: 'LaneFeesRateCard.simplifiedCQuoteDescription',
            minWidth: '25%',
        },
        {
            name: 'description',
            labelKey: 'LaneFeesRateCard.quoteDescription',
            minWidth: '25%',
        },
        {
            name: 'currency',
            labelKey: 'LaneFeesRateCard.currency',
            componentName: 'EnumValue',
            allowedValuesEnum: ContractCurrency,
            filterField: 'currency',
            filterType: FilterType.Array,
            minWidth: '7%',
        },
        {
            name: 'feeValue',
            labelKey: 'LaneFeesRateCard.feeValue',
            alignTextRight: true,
            minWidth: '6%',
        },
    ],
}

export default config
